import { firebase } from '@firebase/app';
import 'firebase/auth';
import 'firebase/database';

const config = {
	apiKey: 'AIzaSyCGnhDKLzl8JmOBVFhcXhXk-v6DcDD7Ppc',
	authDomain: 'gdg-kl.firebaseapp.com',
	databaseURL: 'https://io-extended-android-19.firebaseio.com/',
	projectId: 'io-extended-android-19',
	storageBucket: 'gdg-kl.appspot.com',
	messagingSenderId: '824291119922'
};
firebase.initializeApp(config);

export default firebase;


// WEBPACK FOOTER //
// ./components/firebase.js